import { createStore } from 'vuex';
import i18n from '@/i18n';
import axios from 'axios';
import helpers from './../helpers/index';

const endpoints = {
    applications: '/api/v1/applications',
    candidates: '/api/v1/candidates',
    configurations: '/api/v1/configurations',
    documents: '/api/v1/documents',
    lookups: '/api/v1/lookups',
    units: '/api/v1/units',
};

export default createStore({
    state: {
        appLanguages:
            typeof window._HR !== 'undefined'
                ? window._HR.navigationLanguages
                : { label: 'English', code: 'en' },
        selectedLanguage:
            typeof window._HR !== 'undefined'
                ? window._HR.selectedLanguage
                : 'en',
        currentSite:
            typeof window._HR !== 'undefined' ? window._HR.currentSite : 'COR',

        // LOOKUPS : START
        applicationCycleTypes: null,
        statuses: null,
        unitLinkStatuses: null,
        // genders: null,
        // countries: null,
        // languages: null,
        // languageLevels: null,
        // studyFields: null,
        // studyLevels: null,
        // units: null,
        genders: typeof window._HR !== 'undefined' ? window._HR.genders : [],
        countries:
            typeof window._HR !== 'undefined' ? window._HR.countries : {},
        applicationStatuses:
            typeof window._HR !== 'undefined' ? window._HR.statuses : [],
        languages:
            typeof window._HR !== 'undefined' ? window._HR.languages : [],
        languageLevels:
            typeof window._HR !== 'undefined' ? window._HR.languageLevels : [],
        studyFields:
            typeof window._HR !== 'undefined' ? window._HR.studyFields : [],
        studyLevels:
            typeof window._HR !== 'undefined' ? window._HR.studyLevels : [],
        units: typeof window._HR !== 'undefined' ? window._HR.units : [],

        grades: typeof window._HR !== 'undefined' ? window._HR.grades : [],
        functions:
            typeof window._HR !== 'undefined' ? window._HR.functions : [],
        applicantCategories:
            typeof window._HR !== 'undefined'
                ? window._HR.applicantCategories
                : [],
        officialEligibilityCategories:
            typeof window._HR !== 'undefined'
                ? window._HR.officialEligibilityCategories
                : [],
        castEligibilityCategories:
            typeof window._HR !== 'undefined'
                ? window._HR.castEligibilityCategories
                : [],
        contractAgentCastEligibilityCategories:
            typeof window._HR !== 'undefined'
                ? window._HR.contractAgentCastEligibilityCategories
                : [],
        // grades: null,
        // functions: null,
        // applicantCategories: null,
        // officialEligibilityCategories: null,
        positions: typeof window._HR !== 'undefined' ? window._HR.positions : [],
        // LOOKUPS : END
        // europeanInstitutions: null,
        europeanInstitutions:
            typeof window._HR !== 'undefined'
                ? window._HR.europeanInstitutions
                : [],
        // govOfficialTypes: null,
        govOfficialTypes:
            typeof window._HR !== 'undefined'
                ? window._HR.govOfficialTypes
                : [],
        candidateProfile: {
            id: null,
            usualLastName: null,
            usualFirstName: null,
            gender: null,
            identifyAs: null,
            natIsoCountryCode: null,
            nat2IsoCountryCode: null,
            birthDate: null,
            birthCity: null,
            birthIsoCountryCode: null,
            phoneNumber: null,
            gsmNumber: null,
            email: null,
            secondaryEmail: null,
        },
        requiredFields: [
            'gender',
            'birthDate',
            'birthCity',
            'birthIsoCountryCode',
            'natIsoCountryCode',
            'phoneNumber',
            'adStreet',
            'adPostalCode',
            'adCity',
            'adIsoCountryCode',
            'organisationName',
            'experienceType',
            'occupation',
            'natureCode',
            'title',
            'details',
            'code',
            'unitId',
            'comments',
            'langCode',
            'speakConversCode',
            'speakExpressCode',
            'understOralCode',
            'understReadCode',
            'writtenCode',
            'schoolName',
            'diploma',
            'studyType',
            'studyLevel',
            'studyStartDate',
            'experienceStartDate',
            'trainingStartDate',
            'trainingEndDate',
            'durationMonths',
            'category',
            // 'organisationCode',
            // 'applicantCategory'
            // "durationWeeks",
        ],
        trainingDurations: [
            { label: '1', value: 1 },
            { label: '2', value: 2 },
            { label: '3', value: 3 },
            { label: '4', value: 4 },
            { label: '5', value: 5 },
            { label: '6', value: 6 },
        ],
        applications: null,
        openings: null,
        candidateProfileErrors: {},
        wizardStructure: null,
        wizardData: null,
        wizardErrors: {},
        focusedBlock: null,
        appLoading: null,
        translations: null,
        configuration: null,
    },
    getters: {
        translations: (state) => state.translations,
        appLanguages: (state) => state.appLanguages,
        selectedLanguage: (state) => state?.selectedLanguage?.toLowerCase(),
        configuration: (state) => state.configuration,
        currentSite: (state) => state?.currentSite?.toLowerCase(),
        // currentSite: (state) =>
        //     state?.configuration?.currentSite?.toLowerCase(),
        environment: (state) => state?.configuration?.environment,
        releaseVersion: (state) => state.configuration?.releaseVersion,
        isDevEnv: (state) =>
            state.configuration?.environment?.toLowerCase() === 'development',
        isAcceptEnv: (state) =>
            state.configuration?.environment?.toLowerCase() === 'acceptance',
        isProdEnv: (state) =>
            state.configuration?.environment?.toLowerCase() === 'production',
        isCORSite: (state) => state.currentSite?.toLowerCase() === 'cor',
        isEESCSite: (state) => state.currentSite?.toLowerCase() === 'eesc',
        // isCORSite: (state) =>
        //     state.configuration?.currentSite?.toLowerCase() === 'cor',
        // isEESCSite: (state) =>
        //     state.configuration?.currentSite?.toLowerCase() === 'eesc',
        isRegistrationFlow: () => location.pathname.search('wizard') > -1,
        genders: (state) => state.genders,
        countries: (state) => state.countries,
        applications: (state) => state.applications,
        openings: (state) => state.openings,
        candidateProfile: (state) => state.candidateProfile,
        candidateProfileErrors: (state) => state.candidateProfileErrors,
        wizardErrors: (state) => state.wizardErrors,
        // wizardStructure: (state) => state.wizardStructure,
        wizardStructure: (state) => state.wizardStructure,
        blockErrorMessage: (state) => (blockName, subBlockName) => {
            const errorPath = `${blockName}${
                subBlockName ? '.' + subBlockName : ''
            }`;
            if (
                Object.prototype.hasOwnProperty.call(
                    state.wizardErrors,
                    errorPath
                )
            ) {
                return state.wizardErrors[errorPath];
            }
        },
        errorMessage: (state) => (fieldKey, blockName, subBlockName, index) => {
            // console.log(
            //     'error message',
            //     fieldKey,
            //     blockName,
            //     subBlockName,
            //     index
            // );
            const errorPath = `${blockName}${
                subBlockName ? '.' + subBlockName : ''
            }${typeof index !== 'undefined' ? '[' + index + ']' : ''}${
                fieldKey ? '.' + fieldKey : ''
            }`;
            // console.log('error path', errorPath);

            if (
                Object.prototype.hasOwnProperty.call(
                    state?.wizardErrors,
                    errorPath
                )
            ) {
                // console.log('are si error  path', state?.wizardErrors?.[errorPath])

                return state?.wizardErrors?.[errorPath];
            }
        },
        requiredFields: (state, getters) => {
            //We add specific required fields based on the application type;
            if (getters.applicationTypeIsTrainee) {
                return [
                    ...state.requiredFields,
                    'studyStartDate',
                    'studyCountryCode',
                    'experienceCountryCode',
                    'traineeshipRequired'
                ];
            } else if (getters.applicationTypeIsTraingov) {
                return [
                    ...state.requiredFields,
                    'studyCountryCode',
                    'experienceCountryCode',
                ];
            } else if (getters.applicationTypeIsCa || getters.applicationTypeIsTa){
                return [
                    ...state.requiredFields,
                    'experienceComment',
                    'motivationComment',
                    'skillsComment'
                ]
            } else {
                return state.requiredFields;
            }
        },
        isFieldRequired: (state, getters) => (fieldKey) => {
            return getters.requiredFields.includes(fieldKey);
        },
        studyFields: (state) => state.studyFields,
        studyLevels: (state) => state.studyLevels,
        languages: (state) => state.languages,
        languageLevels: (state) => state.languageLevels,
        units: (state) => state.units,
        govOfficialTypes: (state) => state.govOfficialTypes,
        europeanInstitutions: (state, getters) => 
            {
                if (getters.applicationTypeIsTrainee || getters.applicationTypeIsShort) {
                    return state.europeanInstitutions
                        .map(item => {
                            if (item.code === "EC" && item.lang ==="FR") {
                                return { ...item, name: "Commission européenne (y compris Délégations et Bureaux de Représentation, agences et agences exécutives)" };
                            } else if (item.code === "EC" && item.lang==="EN") {
                                return { ...item, name: "European Commission (including Delegations and Representation offices, agencies and executive agencies)" };
                            }
                            return item;
                        })
                        .filter(item =>
                            item.code !== "OTHER"
      );
                }else{
                    return state.europeanInstitutions.filter(item =>
                        item.code !== "EIB"        
                           && item.code !== "ECB"
                           && item.code !== "OOPEC"
                           && item.code !== "EPSO"
                           && item.code !== "EAS"
                           && item.code !== "EPDS"
                           && item.code !== "EIF"
                    );
                }
            },  
        trainingDurations: (state, getters) => {
            return state.trainingDurations.filter((duration) => {
                if (
                    getters.applicationTypeIsTraingov &&
                    duration.value >= 2 &&
                    duration.value <= 6
                ) {
                    return duration;
                } else if (getters.applicationTypeIsShort) {
                    if (
                        getters.isCORSite &&
                        duration.value >= 1 &&
                        duration.value <= 4
                    ) {
                        return duration;
                    } else if (
                        !getters.isCORSite &&
                        duration.value >= 1 &&
                        duration.value <= 3
                    ) {
                        return duration;
                    }
                } else if (getters.applicationTypeIsTrainee) {
                    return duration;
                }
            });
            // return state.trainingDurations;
        },
        minDateValue() {
            const minDate = new Date();
            minDate.setFullYear(minDate.getFullYear() - 65);
            return minDate;
        },
        maxDateValue() {
            const maxDate = new Date();
            maxDate.setFullYear(maxDate.getFullYear() - 18);
            return maxDate;
        },
        minStartDateValue: (state) => {
            var minDate = new Date();
            if (state.wizardData.applicationBlocks.personalData.birthDate) {
                minDate = new Date(
                    state.wizardData.applicationBlocks.personalData.birthDate
                );
                minDate.setFullYear(minDate.getFullYear() + 16);
            }
            return minDate;
        },
        experienceData: (state) =>
            state.wizardData.applicationBlocks.experience,
        euExperienceData: (state) =>
            state.wizardData.applicationBlocks.euExperience,
        traineeshipRequiredData: (state) =>
            state.wizardData.applicationBlocks.traineeshipRequired,
        specialNeedsData: (state) => state.wizardData.applicationBlocks.specialNeeds,
        govOfficialTypeData: (state) =>
            state.wizardData.applicationBlocks.govOfficialType,
        interestData: (state) => state.wizardData.applicationBlocks.interest,
        languageData: (state) => state.wizardData.applicationBlocks.language,
        otherSkillData: (state) =>
            state.wizardData.applicationBlocks.otherSkill,
        personalData: (state) =>
            state.wizardData.applicationBlocks.personalData,
        residenceData: (state) => state.wizardData.applicationBlocks.residence,
        studyData: (state) => state.wizardData.applicationBlocks.study,
        officialEligibilityData: (state) =>
            state.wizardData.applicationBlocks.officialEligibility,
        castEligibilityData: (state) =>
            state.wizardData.applicationBlocks.castEligibility,
        documentsData: (state) => state.wizardData.documents,
        trainingDurationData: (state) =>
            state.wizardData.applicationBlocks.trainingDuration,
        wizardData: (state) => state.wizardData,
        cycleApplicantCategory: (state) =>
            state?.wizardData?.applicationCycle?.applicantCategory,
        applicationCycle: (state) => state.wizardData?.applicationCycle,
        // cycleApplicantCategory:(state) => 'official',
        canApply: (state) => {
            if (state.wizardStructure && state.wizardStructure.steps) {
                let canApply = true;
                state.wizardStructure.steps.map((step) => {
                    if (!step.isCompleted) {
                        canApply = false;
                    }
                });
                return canApply;
            } else {
                return false;
            }
        },
        focusedBlock: (state) => state.focusedBlock,
        isRegisteredApplication: (state) => state.wizardData.status !== 'DRAFT',
        applicationTypeIsTrainee: (state) =>
            state.wizardData && state.wizardData.applicationType === 'TRAINEE',
        applicationTypeIsTraingov: (state) =>
            state.wizardData && state.wizardData.applicationType === 'TRAINGOV',
        applicationTypeIsShort: (state) =>
            state.wizardData && state.wizardData.applicationType === 'SHORT',
        applicationTypeIsOfficial: (state) =>
            state.wizardData && state.wizardData.applicationType === 'OFFICIAL',
        applicationTypeIsCa: (state) => 
            state.wizardData && state.wizardData.applicationType === 'CA',
        applicationTypeIsTa: (state) => 
            state.wizardData && state.wizardData.applicationType === 'TA',
        appLoading: (state) => state.appLoading,

        applicationCycleTypes: (state) => state.applicationCycleTypes,
        applicationCycles: (state) => state.applicationCycles,
        statuses: (state) => state.statuses,
        unitLinkStatuses: (state) => state.unitLinkStatuses,
        countryLabel: (state) => (countryCode) => {
            let result;
            if (state.countries) {
                result = state.countries.find(
                    (country) => country.code === countryCode
                );
            }
            return result?.name || '';
        },
        languageLabel: (state) => (languageCode) => {
            let result;
            if (state.languages && languageCode) {
                result = state.languages.find(
                    (language) => language.code === languageCode
                );
            }
            return result?.name || '';
        },
        studyFieldLabel: (state) => (studyCode) => {
            let result;
            if (state.studyFields && studyCode) {
                result = state.studyFields.find(
                    (study) => study.code === studyCode
                );
            }
            return result?.name || '';
        },
        studyLevelLabel: (state) => (levelCode) => {
            let result;
            if (state.studyLevels && levelCode) {
                result = state.studyLevels.find(
                    (level) => level.code === levelCode
                );
            }
            return result?.name || '';
        },
        unitLabel: (state) => (unitId) => {
            let result;
            if (state.units && unitId) {
                result = state.units.find((unit) => unit.id == unitId);
            }
            return result?.name || '';
        },
        unitDisplayName: (state) => (unitId) => {
            let result;
            if (state.units && unitId) {
                result = state.units.find((unit) => unit.id == unitId);
            }
            return `${result?.displayName} (${result?.code})` || '';
        },
        europeanInstitutionsLabel: (state) => (statusCode) => {
            let result;
            if (state.europeanInstitutions) {
                result = state.europeanInstitutions.find(
                    (status) => status.code === statusCode
                );
            }
            return result ? result?.text : '';
        },
        grades: (state) => {
            return state.grades;
        },
        functions: (state) => {
            return state.functions;
        },
        functionLabel: (state) => (functionCode) => {
            let result;
            if (state.functions && functionCode) {
                result = state.functions.find(
                    (func) => func.code == functionCode
                );
            }
            return result?.name || '';
        },
        applicantCategories: (state) => {
            return state.applicantCategories;
        },
        applicantCategoryLabel: (state) => (code) => {
            let result;
            if (state.applicantCategories && code) {
                result = state.applicantCategories.find(
                    (category) => category.code == code
                );
            }
            return result?.name || '';
        },
        positions: (state) => {
            return state.positions;
        },
        officialEligibilityCategories: (state) => {
            return state.officialEligibilityCategories;
        },
        eligibilityCategoryLabel: (state) => (code) => {
            let result;
            if (state.officialEligibilityCategories) {
                result = state.officialEligibilityCategories.find(
                    (category) => category.code === code
                );
            }
            return result ? result?.name : '';
        },
        eligibilityCategoryDescription: (state) => (code) => {
            let result;
            if (state.officialEligibilityCategories) {
                result = state.officialEligibilityCategories.find(
                    (category) => category.code === code
                );
            }
            return result ? result?.description : '';
        },
        castEligibilityCategories: (state) => {
            return state.castEligibilityCategories;
        },
        gradeLabel: (state) => (code) => {
            let result;
            if (state.grades) {
                result = state.grades.find((grade) => grade.code === code);
            }
            return result ? result?.name : '';
        },
        applicationStatusIcon: () => (statusCode) => {
            let statusIcon;
            switch (statusCode) {
                case 'REG':
                    statusIcon = 'fas fa-check-double';
                    break;
                case 'SELECTED':
                    statusIcon = 'fas fa-trophy';
                    break;
                case 'DRAFT':
                    statusIcon = 'fas fa-pencil';
                    break;
                case 'DELETED':
                    statusIcon = 'fas fa-trash';
                    break;
                case 'PRESELECTED':
                    statusIcon = 'fas fa-clipboard-check';
                    break;
                case 'RESERVE':
                    statusIcon = 'fas fa-clipboard-list';
                    break;
                case 'WITHDRAWN':
                    statusIcon = 'fas fa-user-slash';
                    break;
                default:
                    statusIcon = 'fas fa-check';
                    break;
            }
            return statusIcon;
        },
        privacyUrl: (state, getters) => {
            // let result = getters.isCORSite
            //     ? `https://cor.europa.eu/en/about/Documents/Traineeships/PS-E2-Traineeship-2018-7-${getters.selectedLanguage}.pdf`
            //     : `https://www.eesc.europa.eu/${getters.selectedLanguage}/work-with-us/traineeships/data-protection-notice`;
            let result = 'https://ecas.ec.europa.eu/cas/privacyStatement.html';

            if (
                state?.wizardData &&
                state?.wizardData?.applicationCycle?.applicationType?.privacyUrl
            ) {
                result =
                    state?.wizardData?.applicationCycle?.applicationType?.privacyUrl?.replace(
                        '{lang}',
                        getters.selectedLanguage
                    );
            }

            return result;
        },
        contactUrl: (state, getters) => {
            let result = getters.isCORSite
                ? getters.selectedLanguage === 'en' ?
                    'https://cor.europa.eu/en/contact-us' : 
                    'https://cor.europa.eu/fr/nous-contacter'
                : `https://www.eesc.europa.eu/${getters.selectedLanguage}/general-contact-form`;
            if (
                !getters.isCORSite && 
                state?.wizardData &&
                state?.wizardData?.applicationCycle?.applicationType
                    ?.officeEmail
            ) {
                result =
                    'mailto:' +
                    state?.wizardData?.applicationCycle?.applicationType
                        ?.officeEmail;
            }

            return result;
        },
        appLogoUrl: (state, getters) => {
            let result = getters.isCORSite
                ? `https://cor.europa.eu/${getters.selectedLanguage}`
                : `https://www.eesc.europa.eu/${getters.selectedLanguage}`;

            if (state?.wizardData) {
                result =
                    state?.wizardData?.applicationCycle?.applicationType?.officialUrl?.replace(
                        '{lang}',
                        getters.selectedLanguage
                    );
            }

            return result;
        },
    },
    mutations: {
        setSelectedLanguage(state, newlangCode) {
            state.selectedLanguage = newlangCode.toLowerCase();
            i18n.global.locale = state.selectedLanguage;

            if (location.pathname === '/') {
                window.history.pushState('', '', `/${state.selectedLanguage}/`);
                location.reload();
            }

            var reg = new RegExp(
                '(' + `/${window._HR.selectedLanguage}` + ')',
                'gi'
            );
            location.pathname = location.pathname.replace(
                reg,
                `/${state.selectedLanguage}`
            );
        },
        setApplications(state, applications) {
            state.applications = applications;
        },
        setOpenings(state, openings) {
            state.openings = openings;
        },
        setCandidateProfile(state, candidateProfile) {
            state.candidateProfile = candidateProfile;
        },
        setCandidateProfileErrors(state, candidateProfileErrors) {
            state.candidateProfileErrors = candidateProfileErrors;
        },
        setWizardErrors(state, wizardErrors) {
            state.wizardErrors = wizardErrors;
        },
        setWizardStructure(state, wizardStructure) {
            // const respWithDocumentsInserted = wizardStructure;
            // respWithDocumentsInserted.steps[0].blocks.push({
            //     id:11,
            //     maxItems:1,
            //     minItems:1,
            //     name:"officialEligibility",
            //     orderNr:1,
            //     stepNr:1,
            //     uploadDocs:true
            // })
            // state.wizardStructure = respWithDocumentsInserted;
            state.wizardStructure = wizardStructure;
        },
        setWizardData(state, wizardData) {
            // const respWithDocumentsInserted =  {
            //     ...wizardData,
            //     applicationBlocks: {
            //         ...wizardData.applicationBlocks,
            //         officialEligibility: {
            //             documents: '111'
            //         }
            //     }
            // }
            // console.log('respWithDocumentsInserted', respWithDocumentsInserted)

            // state.wizardData = respWithDocumentsInserted;
            state.wizardData = wizardData;
        },
        setStepsStatus(state) {
            const tempWizardStructure = { ...state.wizardStructure };
            for (const i in tempWizardStructure.steps) {
                let stepHasError = false,
                    stepCompleted = true;

                tempWizardStructure.steps[i].blocks.map((stepBlock) => {
                    // STEP COMPLETED  : START //
                    Object.keys(state.wizardData.applicationBlocks).map(
                        (appBlock) => {
                            if (
                                stepBlock.name === appBlock &&
                                !state.wizardData.applicationBlocks[appBlock]
                                    .isValid
                            ) {
                                stepCompleted = false;
                            }
                        }
                    );
                    // STEP COMPLETED  : END //
                    // =========================== //
                    // STEP HAS ERROR  : START //
                    if (
                        Object.keys(state.wizardErrors).filter((error) => {
                            // if we find any block name in the wizardErrors object it means the stepHasError + stepcompleted must be false;
                            return error.split('.')[0] === stepBlock.name;
                        }).length
                    ) {
                        stepHasError = true;
                        stepCompleted = false;
                    }
                    // STEP HAS ERROR  : END //
                });
                tempWizardStructure.steps[i].hasError = stepHasError;
                tempWizardStructure.steps[i].isCompleted = stepCompleted;
            }
            state.wizardStructure = tempWizardStructure;
        },
        setFocusedBlock(state, focusedBlock) {
            state.focusedBlock = focusedBlock;
        },
        // LOOKUPS : START
        setApplicationCyclesTypes(state, applicationCycleTypes) {
            state.applicationCycleTypes = applicationCycleTypes;
        },
        setGenders(state, genders) {
            state.genders = genders;
        },
        setGovOfficialTypes(state, govOfficialTypes) {
            state.govOfficialTypes = govOfficialTypes;
        },
        setCountries(state, countries) {
            state.countries = countries;
        },
        setLanguages(state, languages) {
            state.languages = languages;
        },
        setLanguageLevels(state, languageLevels) {
            state.languageLevels = languageLevels;
        },
        setStatuses(state, statuses) {
            state.statuses = statuses;
        },
        setUnitLinkStatuses(state, unitLinkStatuses) {
            state.unitLinkStatuses = unitLinkStatuses;
        },
        setStudyFields(state, studyFields) {
            state.studyFields = studyFields;
        },
        setStudyLevels(state, studyLevels) {
            state.studyLevels = studyLevels;
        },
        setEuropeanInstitutions(state, europeanInstitutions) {
            state.europeanInstitutions = europeanInstitutions;
        },
        setGrades(state, grades) {
            state.grades = grades;
        },
        setFunctions(state, functions) {
            state.functions = functions;
        },
        setApplicantCategories(state, applicantCategories) {
            state.applicantCategories = applicantCategories;
        },
        setOfficialEligibilityCategories(state, officialEligibilityCategories) {
            state.officialEligibilityCategories = officialEligibilityCategories;
        },
        setCastEligibilityCategories(state, castEligibilityCategories) {
            state.castEligibilityCategories = castEligibilityCategories;
        },
        setContractAgentCastEligibilityCategories(state, contractAgentCastEligibilityCategories) {
            state.contractAgentCastEligibilityCategories = contractAgentCastEligibilityCategories;
        },
        setPositions(state, positions) {
            state.positions = positions;
        },
        
        // LOOKUPS : END
        setUnits(state, units) {
            state.units = units;
        },
        setTranslations(state, translations) {
            state.translations = translations;
            i18n.global.locale = state.selectedLanguage;
            // i18n.global.setLocaleMessage(
            //     state.selectedLanguage,
            //     translations[state.selectedLanguage]
            // );
        },
        setConfiguration(state, configuration) {
            state.configuration = configuration;
        },
        setAppLoading(state, appLoading) {
            state.appLoading = appLoading;
        },
    },
    actions: {
        clearSession() {
            sessionStorage.clear();
            localStorage.clear();
        },
        redirectToDashboard() {
            location.href = `/${this.state.selectedLanguage?.toLowerCase()}/dashboard`;
        },
        changeSelectedLanguage({ commit }, newlangCode) {
            commit('setSelectedLanguage', newlangCode);
        },
        loadApplications({ commit }) {
            commit('setAppLoading', true);
            return new Promise((resolve, reject) => {
                axios.get(`${endpoints.applications}`).then(
                    (response) => {
                        commit('setApplications', response.data);
                        commit('setAppLoading', false);
                        resolve(response);
                    },
                    (error) => {
                        commit('setAppLoading', false);
                        reject(error);
                    }
                );
            });
        },
        loadOpenings({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${endpoints.applications}/openings`).then(
                    (response) => {
                        commit('setOpenings', response.data);
                        resolve(response);
                    },
                    (error) => {
                        reject(error);
                    }
                );
            });
        },
        loadCandidateProfile({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${endpoints.candidates}/me`).then(
                    (response) => {
                        commit('setCandidateProfile', response.data);
                        resolve(response);
                    },
                    (error) => {
                        reject(error);
                    }
                );
            });
        },
        updateCandidateProfile({ commit, dispatch }, apiData) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`${endpoints.candidates}/me`, apiData)
                    .then(
                        (response) => {
                            dispatch('clearCandidateProfileErrors');
                            commit('setCandidateProfile', response.data);
                            resolve(response);
                        },
                        (error) => {
                            if (error.response.data.errors) {
                                const errors = {};
                                for (const i in error.response.data.errors) {
                                    errors[i] =
                                        error.response.data.errors[i][0];
                                }
                                commit('setCandidateProfileErrors', errors);
                            }
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        // eslint-disable-next-line no-empty-pattern
        withdrawApplication({}, applicationId) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${endpoints.applications}/${applicationId}/withdraw`)
                    .then(
                        (response) => {
                            resolve(response);
                        },
                        (error) => {
                            reject(error);
                        }
                    );
            });
        },
        // eslint-disable-next-line no-empty-pattern
        importApplication({}, formData) {
            return new Promise((resolve, reject) => {
                axios.post(`${endpoints.applications}/import`, formData).then(
                    (response) => {
                        resolve(response);
                    },
                    (error) => {
                        reject(error);
                    }
                );
            });
        },
        clearCandidateProfileErrors({ commit }) {
            commit('setCandidateProfileErrors', {});
        },
        clearWizardErrors({ commit }) {
            commit('setWizardErrors', {});
        },
        clearBlockErrors({ commit }, blockName) {
            let invalidInputs = { ...this.state.wizardErrors };
            for (const i in invalidInputs) {
                const errorBlockName = i.split('.')[0];
                if (blockName === errorBlockName) {
                    delete invalidInputs[i];
                }
            }
            commit('setWizardErrors', invalidInputs);
            commit('setStepsStatus');
        },
        loadWizard({ commit }, applicationType) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.configurations}/${applicationType}`)
                    .then(
                        (response) => {
                            commit('setWizardStructure', response.data);
                            resolve(response);
                        },
                        (error) => {
                            reject(error);
                        }
                    );
            });
        },
        // eslint-disable-next-line no-empty-pattern
        createApplication({}, model) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`${endpoints.applications}`, model)
                    .then(
                        (response) => {
                            resolve(response.data);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadApplicationData({ commit }, application) {
            return new Promise((resolve, reject) => {
                axios
                    .get(
                        `${endpoints.applications}/${application.id}?includeValidationErrors=${application.includeValidationErrors}`
                    )
                    .then(
                        (response) => {
                            commit('setWizardData', response.data.model);
                            if (
                                response.data.errors &&
                                JSON.stringify(response.data.errors) !== '{}' &&
                                this.state.wizardData.status !== 'DRAFT'
                            ) {
                                // console.log(
                                //     'dase1312312',
                                //     response.data,
                                //     response.data.errors &&
                                //         JSON.stringify(response.data.errors) !==
                                //             '{}' &&
                                //         this.state.wizardData.status !== 'DRAFT'
                                // );
                                commit(
                                    'setWizardErrors',
                                    helpers.extractWizardErrors(
                                        response.data.errors,
                                        this.state.wizardErrors
                                    )
                                );
                                commit('setStepsStatus');
                            }
                            resolve(response.data);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        validateBlock({ commit }, data) {
            return new Promise((resolve, reject) => {
                let invalidInputs = { ...this.state.wizardErrors };

                const blockName = data.blockName,
                    blockData = data.blockData;
                for (const childBlockKey in blockData) {
                    const path = `${blockName}.${childBlockKey}`;

                    if (this.getters.requiredFields.includes(childBlockKey)) {
                        if (
                            !blockData[childBlockKey] ||
                            !JSON.stringify(blockData[childBlockKey]).length
                        ) {
                            invalidInputs[path] = 'val_input_required';
                        } else {
                            delete invalidInputs[path];
                        }
                    }
                    for (const key in blockData[childBlockKey]) {
                        if (this.getters.requiredFields.includes(key)) {
                            const path = `${blockName}.${childBlockKey}.${key}`;
                            if (
                                !blockData[childBlockKey][key] ||
                                !JSON.stringify(blockData[childBlockKey][key])
                                    .length
                            ) {
                                invalidInputs[path] = 'val_input_required';
                            } else {
                                delete invalidInputs[path];
                            }
                        }
                        if (blockData[childBlockKey][key]) {
                            for (const fieldKey in blockData[childBlockKey][
                                key
                            ]) {
                                if (
                                    this.getters.requiredFields.includes(
                                        fieldKey
                                    )
                                ) {
                                    const path = `${blockName}.${childBlockKey}[${key}].${fieldKey}`;
                                    if (
                                        !blockData[childBlockKey][key][
                                            fieldKey
                                        ] ||
                                        !JSON.stringify(
                                            blockData[childBlockKey][key][
                                                fieldKey
                                            ]
                                        ).length
                                    ) {
                                        invalidInputs[path] =
                                            'val_input_required';
                                    } else {
                                        delete invalidInputs[path];
                                    }
                                }
                            }
                        }
                    }
                }
                if (JSON.stringify(invalidInputs[blockName]) === '{}') {
                    delete invalidInputs[blockName];
                }
                if (JSON.stringify(invalidInputs) === '{}') {
                    invalidInputs = null;
                }
                if (!invalidInputs) {
                    resolve(true);
                    commit('setWizardErrors', {});
                } else {
                    if (
                        !Object.keys(invalidInputs).filter((key) =>
                            key.includes(blockName)
                        ).length
                    ) {
                        resolve(true);
                    } else {
                        reject();
                    }
                    commit('setWizardErrors', invalidInputs);
                }
                commit('setStepsStatus');
            });
        },
        updateBlock({ commit }, applicationData) {
            commit('setAppLoading', true);
            return new Promise((resolve, reject) => {
                axios
                    .put(
                        `${endpoints.applications}/${applicationData.application.applicationId}`,
                        applicationData
                    )
                    .then(
                        (response) => {
                            commit('setAppLoading', false);
                            if (response.data.success) {
                                commit('setWizardData', response.data.model);
                                if (
                                    response.data.errors &&
                                    JSON.stringify(response.data.errors) !==
                                        '{}'
                                ) {
                                    commit(
                                        'setWizardErrors',
                                        helpers.extractBlockErrors(
                                            applicationData.blockName,
                                            response.data.errors,
                                            this.state.wizardErrors
                                        )
                                    );
                                }
                                resolve(response);
                            } else {
                                if (response.data.errors) {
                                    commit(
                                        'setWizardErrors',
                                        helpers.extractWizardErrors(
                                            response.data.errors,
                                            this.state.wizardErrors,
                                            false
                                        )
                                    );
                                }
                                reject(response);
                            }
                            commit('setStepsStatus');
                        },
                        (error) => {
                            commit('setAppLoading', false);
                            if (error.response.data.errors) {
                                commit(
                                    'setWizardErrors',
                                    helpers.extractWizardErrors(
                                        error.response.data.errors,
                                        this.state.wizardErrors
                                    )
                                );
                                commit('setStepsStatus');
                            }
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        commit('setAppLoading', false);
                        reject(error);
                    });
            });
        },
        submitApplication({ commit }, applicationData) {
            commit('setAppLoading', true);
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        `${endpoints.applications}/${applicationData.applicationId}/submit`,
                        applicationData
                            ? applicationData
                            : this.state.wizardData
                    )
                    .then(
                        (response) => {
                            if (!response.data.success) {
                                if (response.data.errors) {
                                    commit(
                                        'setWizardErrors',
                                        helpers.parseErrorObjects(
                                            response.data.errors
                                        )
                                    );
                                    commit('setStepsStatus');
                                }
                            }
                            resolve(response);
                        },
                        (error) => {
                            if (error.response.data.errors) {
                                commit(
                                    'setWizardErrors',
                                    helpers.extractWizardErrors(
                                        error.response.data.errors,
                                        this.state.wizardErrors
                                    )
                                );
                                commit('setStepsStatus');
                            }
                            reject(error.response.data);
                            commit('setAppLoading', false);
                        }
                    )
                    .catch((error) => {
                        reject(error);
                        commit('setAppLoading', false);
                    });
            });
        },
        triggerSetStepsStatus({ commit }) {
            commit('setStepsStatus');
        },
        focusOnBlock({ commit }, blockData) {
            commit('setFocusedBlock', blockData);
        },
        keepSessionAlive() {
            // Giving the issue that we have between test & acceptance with the session, the quick fix was agreed to have a function that runs every 5 minutes to keep the session alive;
            setInterval(() => {
                axios.get(`${endpoints.applications}/openings`);
            }, 300000); //5 minutes interval;
        },
        // eslint-disable-next-line no-empty-pattern
        loadTasks({}, applicationId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.applications}/${applicationId}/tasks`)
                    .then(
                        (response) => {
                            resolve(response);
                        },
                        (error) => {
                            reject(error);
                        }
                    );
            });
        },
        // eslint-disable-next-line no-empty-pattern
        completeTask({}, taskId) {
            return new Promise((resolve, reject) => {
                console.log(resolve, reject, taskId);
                // axios.post(`${endpoints.documents}/${documentId}`).then(
                //     (response) => {
                //         resolve(response);
                //     },
                //     (error) => {
                //         reject(error);
                //     }
                // );
            });
        },
        // eslint-disable-next-line no-empty-pattern
        uploadDocument({}, formData) {
            return new Promise((resolve, reject) => {
                axios.post(`${endpoints.documents}`, formData).then(
                    (response) => {
                        resolve(response);
                    },
                    (error) => {
                        reject(error.response.data);
                    }
                );
            });
        },
        // eslint-disable-next-line no-empty-pattern
        downloadDocument({}, documentId) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.documents}/${documentId}/download`, {
                        responseType: 'blob',
                    })
                    .then(
                        (response) => {
                            resolve(response);
                        },
                        (error) => {
                            reject(error);
                        }
                    );
            });
        },
        // eslint-disable-next-line no-empty-pattern
        deleteDocument({}, documentId) {
            return new Promise((resolve, reject) => {
                axios.delete(`${endpoints.documents}/${documentId}`).then(
                    (response) => {
                        resolve(response);
                    },
                    (error) => {
                        reject(error);
                    }
                );
            });
        },
        // eslint-disable-next-line no-empty-pattern
        acceptOffer({}, model) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        `${endpoints.applications}/${model.applicationId}/accept-offer`,
                        {
                            keyboardType: model.keyboardType,
                            shortGrantPaymentRefusal: model.shortGrantPaymentRefusal,
                        }
                    )
                    .then(
                        (response) => {
                            resolve(response);
                        },
                        (error) => {
                            reject(error);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        // eslint-disable-next-line no-empty-pattern
        declineOffer({}, applicationId) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        `${endpoints.applications}/${applicationId}/decline-offer`,
                        {}
                    )
                    .then(
                        (response) => {
                            resolve(response);
                        },
                        (error) => {
                            reject(error);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadApplicationTypes({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.lookups}/application-types`)
                    .then(
                        (response) => {
                            commit('setApplicationCyclesTypes', response.data);
                            resolve(response);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadGenders({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.lookups}/genders`)
                    .then(
                        (response) => {
                            commit('setGenders', response.data);
                            resolve(response);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadGovOfficialTypes({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.lookups}/gov-types`)
                    .then(
                        (response) => {
                            commit('setGovOfficialTypes', response.data);
                            resolve(response);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadCountries({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.lookups}/countries`)
                    .then(
                        (response) => {
                            commit('setCountries', response.data);
                            resolve(response);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadLanguages({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.lookups}/languages`)
                    .then(
                        (response) => {
                            commit('setLanguages', response.data);
                            resolve(response);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadLanguageLevels({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.lookups}/language-levels`)
                    .then(
                        (response) => {
                            commit('setLanguageLevels', response.data);
                            resolve(response);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadStatuses({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.lookups}/statuses`)
                    .then(
                        (response) => {
                            commit('setStatuses', response.data);
                            resolve(response);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadStudyFields({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.lookups}/study-fields`)
                    .then(
                        (response) => {
                            commit('setStudyFields', response.data);
                            resolve(response);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadStudyLevels({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.lookups}/study-levels`)
                    .then(
                        (response) => {
                            commit('setStudyLevels', response.data);
                            resolve(response);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadUnitLinkStatuses({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.lookups}/unit-statuses`)
                    .then(
                        (response) => {
                            commit('setUnitLinkStatuses', response.data);
                            resolve(response);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadEuropeanInstitutions({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.lookups}/eu-institutions`)
                    .then(
                        (response) => {
                            commit('setEuropeanInstitutions', response.data);
                            resolve(response.data);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadGrades({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.lookups}/grades`)
                    .then(
                        (response) => {
                            commit('setGrades', response.data);
                            resolve(response);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadFunctions({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.lookups}/functions`)
                    .then(
                        (response) => {
                            commit('setFunctions', response.data);
                            resolve(response);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadApplicantCategories({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.lookups}/applicant-categories`)
                    .then(
                        (response) => {
                            commit('setApplicantCategories', response.data);
                            resolve(response);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadOfficialEligibilityCategories({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.lookups}/eligibility-categories`)
                    .then(
                        (response) => {
                            commit('setOfficialEligibilityCategories', response.data);
                            resolve(response);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadCastEligibilityCategories({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.lookups}/casts`)
                    .then(
                        (response) => {
                            commit('setCastEligibilityCategories', response.data);
                            resolve(response);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadContractAgentCastEligibilityCategories({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.lookups}/contractagent-casts`)
                    .then(
                        (response) => {
                            commit('setContractAgentCastEligibilityCategories', response.data);
                            resolve(response);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadUnits({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.units}`)
                    .then(
                        (response) => {
                            commit(
                                'setUnits',
                                response.data.map((unit) => ({
                                    ...unit,
                                    nameWithCode: `${unit.name} (${unit.code})`,
                                }))
                            );
                            resolve(response);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadTranslations({ commit, state }) {
            commit('setAppLoading', true);
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.lookups}/translations`)
                    .then(
                        (response) => {
                            commit('setTranslations', response.data);
                            if (state?.configuration) {
                                commit('setAppLoading', false);
                            }
                            resolve(response);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadConfiguration({ commit, state }) {
            commit('setAppLoading', true);
            return new Promise((resolve, reject) => {
                axios
                    .get(`${endpoints.lookups}/configuration`)
                    .then(
                        (response) => {
                            commit('setConfiguration', response.data);
                            if (state?.translations) {
                                commit('setAppLoading', false);
                            }
                            resolve(response);
                        },
                        (error) => {
                            reject(error.response.data);
                        }
                    )
                    .catch((error) => {
                        reject(error.response.data);
                    });
            });
        },
        loadAppData() {
            // dispatch('loadTranslations');
            // dispatch('loadConfiguration');
            // dispatch('loadApplicationTypes');
            // dispatch('loadGenders');
            // dispatch('loadCountries');
            // dispatch('loadLanguages');
            // dispatch('loadLanguageLevels');
            // dispatch('loadStatuses');
            // dispatch('loadStudyFields');
            // dispatch('loadStudyLevels');
            // dispatch('loadUnits');
            // dispatch('loadEuropeanInstitutions');
            // dispatch('loadGrades');
            // dispatch('loadFunctions');
            // dispatch('loadApplicantCategories');
            // dispatch('loadofficialEligibilityCategories');
        },
    },
});
